import { NameSummaryFormPL } from '@/components/slides/DataSummary/pl/SummaryForms/NameSummaryFormPL.tsx';
import { ContactSummaryFormPL } from '@/components/slides/DataSummary/pl/SummaryForms/ContactSummaryFormPL.tsx';
import { AddressSummaryFormPL } from '@/components/slides/DataSummary/pl/SummaryForms/AddressSummaryFormPL.tsx';
import { PersonalInfoSummaryFormPL } from '@/components/slides/DataSummary/pl/SummaryForms/PersonalInfoSummaryFormPL.tsx';

export const SummaryFormsPL = () => {
  return (
    <>
      <NameSummaryFormPL />
      <ContactSummaryFormPL />
      <AddressSummaryFormPL />
      <PersonalInfoSummaryFormPL />
    </>
  );
};
